<script setup lang="ts">
/**
 * RinganBilahPercaya — padanan <CaTrustBar> untuk halaman kompres.
 *
 * Hanya menukar <UIcon> dengan SVG inline. Berbeda dari CaTrustBar, komponen
 * ini TIDAK punya daftar butir bawaan: keempat halaman kompres selalu mengirim
 * butirnya sendiri, dan butir bawaan CaTrustBar menyebut hal-hal (masa simpan
 * 24 jam, bantuan WhatsApp) yang tidak berlaku di halaman alat gratis.
 * Mewajibkan `butir` membuat klaim yang salah mustahil masuk diam-diam.
 */
export interface ButirPercaya {
  ikon: string
  judul: string
  detail: string
}

withDefaults(
  defineProps<{ ringkas?: boolean; butir: ButirPercaya[] }>(),
  { ringkas: false }
)
</script>

<template>
  <ul
    class="grid gap-3 sm:gap-4"
    :class="ringkas ? 'grid-cols-2 lg:grid-cols-4' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'"
  >
    <li
      v-for="b in butir"
      :key="b.judul"
      class="flex items-start gap-3 rounded-control bg-surface-2 border border-line p-3.5"
    >
      <RinganIkon :nama="b.ikon" class="size-5 shrink-0 text-brand mt-0.5" />
      <div class="min-w-0">
        <p class="text-sm font-semibold leading-snug text-ink">{{ b.judul }}</p>
        <p class="ca-caption text-muted mt-0.5">{{ b.detail }}</p>
      </div>
    </li>
  </ul>
</template>
